/**
 * Maps a failed ConsumerLogin to the dictionary key the sign-in error screen shows, so a dead login
 * link reads as "this link no longer works" instead of a generic "sign-in failed, try again".
 */

/**
 * Core's ConsumerLogin errors meaning the token itself is unusable here, not a transient failure:
 * no consumer holds it (profile deleted) or it belongs to another shop. Retrying will never help.
 */
const DEAD_LINK_ERRORS = ['Unknown consumer with token', 'Invalid brand for consumer token']

/** The dictionary key describing why ConsumerLogin failed, from the GraphQL error messages it returned. */
export function signInErrorKey(messages: readonly string[] = []): string {
  const deadLink = messages.some((m) => DEAD_LINK_ERRORS.some((prefix) => m.startsWith(prefix)))
  return deadLink ? 'auth.linkInvalid' : 'auth.signInFailed'
}
